import { useCallback } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useCurrentUser } from '@modules-deprecated/app/user'

import { EmberRoute } from '../../../enums/emberRoute'
import { useEmberRouteUrl } from '../../../hooks/routing/useEmberRouteUrl'
import { getCleanReturnUrl } from '../utils/getCleanReturnUrl'
import { buildPayNowOAuthUrl } from '../utils/payNowOAuth'
import { useTrackCardPayment } from './useTrackCardPayment'

export const usePayNowOAuthRedirect = () => {
  const { organization } = useUserOrganization()
  const { user } = useCurrentUser()
  const { url: redirectPath } = useEmberRouteUrl(EmberRoute.SettingsCardPayments)
  const { trackStripeAccountConnectionStarted } = useTrackCardPayment()

  const redirectToOAuth = useCallback(() => {
    if (!redirectPath) {
      return
    }

    const oauthUrl = buildPayNowOAuthUrl({
      organization,
      redirectPath,
      returnUrl: getCleanReturnUrl(),
      user,
    })

    trackStripeAccountConnectionStarted()

    // Intentional full-page navigation to Stripe. The "never use window.location" routing rule targets
    // in-app navigation via the Ember/React history bridge; an external OAuth redirect is a deliberate
    // exception and must leave the SPA entirely.
    window.location.assign(oauthUrl)
  }, [organization, redirectPath, trackStripeAccountConnectionStarted, user])

  return { canRedirect: Boolean(redirectPath), redirectToOAuth }
}
